import React, { useState, useEffect } from 'react';
import { ProgressBar } from 'react-bootstrap';
import img2 from '../assets/Loader/load1.png';
import img1 from '../assets/Loader/load2.png';
import img3 from '../assets/Loader/load3.png';
import img4 from '../assets/Loader/load4.png';
import img5 from '../assets/Loader/load5.png';
import img6 from '../assets/Loader/load6.png';
import img7 from '../assets/Loader/load7.png';
// import img8 from '../assets/Property 1=Variant8.png';
import logo from '../assets/image 107.png';
import union from "../assets/Union.png"

const imgArr = [
  { step: 1, image: img1 },
  { step: 2, image: img2 },
  { step: 3, image: img3 },
  { step: 4, image: img4 },
  { step: 5, image: img5 },
  { step: 6, image: img6 },
  { step: 7, image: img7 },
//   { step: 8, image: img8 },
];

export default function Loader() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => {
        // Only increment, don't reset or reverse
        if (prev + 1 < imgArr.length) {
          return prev + 1;
        } else {
          return prev; // No reverse, once at the end, stop updating
        }
      });
    }, 200); // Change to desired interval (500ms)

    return () => clearInterval(interval);
  }, []);

  const progress = ((currentIndex + 1) / imgArr.length) * 100;

  return (
    <div
    className='bg-[#f8eff2]'
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        textAlign: 'center',
        position:"relative",
        backgroundColor:"#f8eff2"
      }}
    >
      <div className="">
        <img
          src={imgArr[currentIndex].image}
          alt={`Step ${imgArr[currentIndex].step}`}
          style={{ height: '300px',width:"300px", objectFit: 'contain' }}
        />
         <img
    src={union}
    alt="Union"
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: '100px', // adjust size as needed
      width: '100px',
      objectFit: 'contain',
      pointerEvents: 'none',
    }}
  />
      </div>
      <div className=''><img src={logo} alt="" className="fill-[ #6E3B48] text-[#6E3B48]"/></div>
      <div style={{ width: '20%' }} className='mt-3'>
      <ProgressBar style={{ height: '8px', backgroundColor: "#E2B6C1"
 }}>
  <ProgressBar
    now={progress}
    style={{ backgroundColor: '#cc2b52' }}
  />
</ProgressBar>
      </div>
    </div>
  );
}